import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllFileTypes = lazy(() => import("../pages/all-file-types"));

export const FileTypeManagementRouter = [
  {
    path: "/master-management/file-type",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllFileTypes />
          </Suspense>
        ),
      },
    ],
  },
];
